module.exports = {
  RECALCULATE_TASK_CREATE_REQUEST: 'RECALCULATE_TASK_CREATE_REQUEST',
  RECALCULATE_TASK_CREATE_SUCCESS: 'RECALCULATE_TASK_CREATE_SUCCESS',
  RECALCULATE_TASK_CREATE_FAILURE: 'RECALCULATE_TASK_CREATE_FAILURE',
};
